import React from 'react';
import { Editor, Element } from 'slate';

import { AulaPlugin } from '../plugins';
import { toggleBlockType } from '../../lib/commands';
import { getCurrentNode, getCurrentNodeType } from '../../lib/queries';
import { matchesHotkey } from '../../lib/hotkeys';
import { hotkeys } from '../../config/hotkeys';

// eslint-disable-next-line no-shadow
export enum HeadingFormats {
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
}

export const headings: AulaPlugin = (editableProps, editor) => ({
  ...editableProps,
  onKeyDown: (e) => {
    if (editableProps.onKeyDown) editableProps.onKeyDown(e);

    const hotkeyCommand = hotkeys.heading.some((hotkey) =>
      matchesHotkey(hotkey, e)
    );
    if (hotkeyCommand && editor.selection != null) {
      const node = getCurrentNode(editor) as Element;
      const formats = Object.keys(HeadingFormats);
      const nextFormatString =
        formats[formats.indexOf(node?.type as string) + 1];
      const nextFormat = HeadingFormats[nextFormatString as HeadingFormats];
      toggleBlockType(editor, nextFormat, editor.selection);
    }
  },
  renderElement: (props) => {
    const { children, element, attributes } = props;

    const Tag = HeadingFormats[element.type as HeadingFormats] || 'p';
    return <Tag {...attributes}>{children}</Tag>;
  },
});

export const isCurrentHeading = (editor: Editor) => {
  const currentNodeType = getCurrentNodeType(editor);
  return HeadingFormats[currentNodeType as HeadingFormats] != null;
};
